export function roundTo2DpWithoutZeros(count: string | number | null): number {
    return +Number(count).toFixed(2);
}
